import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const RightArrow = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M3 17H26.4L18.337 24.262C18.137 24.45 18 24.712 18 25C18 25.55 18.45 26 19 26C19.262 26 19.488 25.9 19.663 25.738L29.663 16.738C29.875 16.55 29.988 16.276 29.988 16C29.988 15.724 29.863 15.45 29.663 15.262L19.663 6.26202C19.488 6.10002 19.25 5.99902 19 5.99902C18.45 5.99902 18 6.44902 18 6.99902C18 7.29902 18.125 7.56202 18.337 7.73602L26.4 14.999H3C2.45 14.999 2 15.449 2 15.999C2 16.549 2.45 16.999 3 16.999V17Z" />
	</svg>
);

export default RightArrow;
